import { HttpEventType } from '@angular/common/http';
import { Router } from '@angular/router';
import { Component, ElementRef, OnInit, ViewChild, HostListener } from '@angular/core';
import { URLS } from '../../constants/URLS';
import { getVideoStreamFile } from '../../utils/media-url.utils';
import { CategoryContentModel } from '../../_model/category-content-model';
import { CategoryService } from '../../_service/category.service';
import { DownloadProgressService } from '../../_service/download-progress.service';
import { MycontentserviceService } from '../../_service/mycontentservice.service';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { ToastrService } from 'ngx-toastr';
import { MycontentComponent } from '../mycontent/mycontent.component';
import { AppComponent } from 'src/app/app.component';
declare let shaka: any | undefined;
declare var window: any | undefined;


@Component({
  selector: 'app-category',
  templateUrl: './category.component.html',
  // template:   '<div><button (click)="mycontent.getUserWatchList()>getWatchList</button> <app-mycontent #mycontent></app-mycontent> </div>',
  styleUrls: ['./category.component.css']
})
export class CategoryComponent implements OnInit{

  data: any[];
  sections: any[]=[];
  watchList: any[];
  mediaUrl: String = URLS.BASE_URL + '/static/post_videos/';
  // mycontentcompo: any;
  mycontentcompo: MycontentComponent;
  categoriesData: CategoryContentModel[] = [];
  bannerList:any[]=[];

  //ui changes
  popUpBool: boolean = false;
  selectedCotegoryContent: any;
  progressBarPer = 0;
  progressBarId = '';
  downloadingToast = false;
  downloadToastText = '';
  loaderShowHide = true;
  isDownloadedText = false;
  isLoading:boolean=false;
  downloadedData = [];
  @ViewChild('video') video: ElementRef | undefined;
  isVideoPlayerOpened: boolean = false;
userId:string;
id= Math.random();

  positon: any =
    {
      top: "0px",
      left: "0px",
      width: "0px",
    }
  appComponent: any;
  AddButtonCSSStyles() {
    return this.positon;
  };

  // isEnable:false;
  constructor(private categ: CategoryService, private mycontentService: MycontentserviceService, private toaster: ToastrService, private downloadProgressService: DownloadProgressService,private router: Router) { 
   
this.downloadProgressService.downloadCompletedEvent.subscribe( (event)=> {
  this.setDonwloadedVideos();
});

   }
   async setDonwloadedVideos() {
    const content = await this.listContent();
    for(const category of this.bannerList) {
      for(const ele of content) {
        if(ele && ele.originalManifestUri.includes(category.vidLibId)) {
          category.isDownloaded = true;
        }
      }
    }
  }

    ngOnInit() {
      console.log("inside home component latest white lable 2")
      this.isLoading=true;
      // this.getCategoryData();
      this.getChannelInfo();
      // this.initPlayer();
      // this.appComponent = new AppComponent(this.downloadProgressService);
      this.mycontentcompo = new MycontentComponent(this.mycontentService, this.toaster);
    this.userId = localStorage.getItem('userId');
   
      
    }
    
    prepareDownloadData() {
      this.listContent().then( (content) => {
        this.downloadedData = content;
        this.setDownloadedVideos();
        console.log("insisde content listing", this.downloadedData);
      });
    }
        
onErrorEvent(event) {
  // Extract the shaka.util.Error object from the event.
  this.onError(event.detail);
}

 onError(error) {
  // Log the error.
  console.error('Error code', error.code, 'object', error);
}


 listContent() {
  return window.storage.list()
}

 playContent(content) {
  window.player.load(content.offlineUri);
}

 removeContent(content) {
  return window.storage.remove(content.offlineUri);
}

 downloadContent(manifestUri, title) {
  // Construct a metadata object to be stored along side the content.
  // This can hold any information the app wants to be stored with the
  // content.
  const metadata = {
    'title': title,
    'downloaded': Date(),
    'fileSize': this.selectedCotegoryContent.videoFileSize,
    vidLibId: this.selectedCotegoryContent.vidLibId,
    categoryId: this.selectedCotegoryContent.categoryId

  };

  return window.storage.store(manifestUri, metadata);
}


onDownloadClick(manifestUri:string) {
  // this.toastr.success("content downloading..")
   console.log("manifestUri:"+manifestUri);
   const title ='test';
 console.log("title:"+title)
 
 this.appComponent.setDownloadProgress(null, 0);

   // Download the content and then re-enable the download button so
   // that more content can be downloaded.
   this.downloadContent(manifestUri, title)
    //  .then(()=> {
    //    return this.refreshContentList();
    //  })
    //  .then((content) =>{
    //    console.log("then method inside download")
    //    this.setDownloadProgress(null, 1);
    //   //  this.toastr.success("successfully downloaded");
    //   //  downloadButton.disabled = false;
    //  })
    //  .catch((error) =>{
    //    // In the case of an error, re-enable the download button so
    //    // that the user can try to download another item.
    //   //  downloadButton.disabled = false;
    //   //  this.toastr.error("downloadig failed..")
    //    this.onError(error);
    //  });
 }
 
 
 setDownloadedVideos(){
  // if(!this.downloadedData.length) {
  //   this.listContent();
  // }
  for(const service of this.sections){
    for(const category of service.category_data) {
      for(const ele of this.downloadedData) {
        if(ele && ele.originalManifestUri.includes(category.vidLibId)) {
          category.isDownloaded = true;
        }
      }
    }
  }
}

  
//  getCategoryData() {
    
//     this.categ.sectionsdata().subscribe(result => {
//       this.sections = result;
//       console.log(this.sections)
//          this.setDownloadedVideos();
      
//       this.sections.forEach(section=>{
//         this.transformData(section);
//         if(section.categoryName=="Latest Action & Adventure Movies"){
//           section.category_data.forEach(category=>{
//             category.imageUrl = this.fetchImageUrl(category.thumbnail);
//           this.bannerList.push(category);
//        })
//       }
//       });

//       this.mapwatchContent();

//     });

//     console.log(this.bannerList);
//   }
prepareVideoType(category) {
    if(category.isFreeVideo) {
      return 'FREE';
    } else if((category.sub_value && category.sub_value != '0')){
      return category.sub_value;
    } else if((category.unSub_value && category.unSub_value != '0')){
      return category.unSub_value;
    } else {
      return 'Sub';
    }
  }
  getChannelInfo() {
    
    // this.categ.getChannelInfoByUserId().subscribe( (res)=> {
    //   console.log("channel data", res);
    //   localStorage.setItem('channelData', JSON.stringify(res));
    // }, (err) => {
    //   console.log("error block", err);
    //   if(this.userId === null){
    //     this.router.navigate(['/authentication'])
    //   }
    // }
    // , ()=> {
    //   this.getCategoryData();
    // }
    // )
  }
  transformData(data){
    for(const category of data.category_data){
      category.categoryId = data.categoryId;
      
      for(const prop of category.properties){
        switch(prop.name){
          case 'title': category.title = prop.value;
                        break;
          case 'files': const filesList = prop.value.split(',');
                        for(const file of filesList){
                          if(file.includes("thumb_v")){
                            category.thumbnail = file;
                            break;
                          }
                        }
                        break;
          case 'description': category.description = prop.value;
      
                        break;

          case 'duration': category.videoDuration = prop.value;
          category.durationInSeconds = this.convertToSeconds(category.videoDuration);

                        break;
                        case 'file_sizes': category.videoFileSize = this.findVideoFileSize(prop.value);
                        
                        break;
                        case 'free_video': category.isFreeVideo = prop.value; break;
                        case 'series_id': category['series.id'] = prop.value; break;
                        case 'channel': category.channelId = prop.value; break;
                        case 'category': category.genre = prop.value; break;
                        case 'pg_rating': category.rating = prop.value; break;
                        case 'starring': category.starring = prop.value; break;
                        case 'ppv_subscribed': category.sub_value = prop.value; break; 
                        case "ppv_unsubscribed": category.unSub_value = prop.value; break; 
                        case 'size': const valueInMb = Math.floor((prop.value/1024)/1024);  category.videoSizeInMb = valueInMb + 'Mb';

                       }
      }
      category.preparedVideoType = this.prepareVideoType(category);
    }
  }
  async fetchImageUrl(imgUrl) {
    return this.mycontentService.getImageBlob(`${this.mediaUrl}${imgUrl}`);
  }
  convertToSeconds(time: string) {
    const splitTIme = time.split(":");
    return Number(splitTIme[0]) * 60 * 60 + Number(splitTIme[1]) * 60 + Number(splitTIme[2]);
  }


  findVideoFileSize(data: string) {
    const ele = data.split(',').find(item => item.includes('video.mp4'));
    if(ele){
      return ele.split("=")[1];
    }
    return 0;
  }



  /* getUserWatchListContent():any{
   var userId=localStorage.getItem("userId");
 this.mycontentService.getWatchListOfUser(userId).subscribe(result=>{
    return result;
   });
 }
  */

  mapwatchContent() {

    var usrId = localStorage.getItem("userId");
    this.mycontentService.getWatchListOfUser(usrId).subscribe(watchresult => { //need to dynamic it 126
      this.watchList = watchresult;

      this.sections.forEach(section => {
        section.category_data.forEach(category => {
          category.isEnable = false;
          this.watchList.forEach(wlitem => {
            if (category.vidLibId == wlitem.vidLibId) {
              category.isEnable = true;
            }
          })
        })
      })
    });
this.isLoading=false
  }

  handleWatchList(selectedCotegoryContent) {
    if(selectedCotegoryContent.isEnable){
      this.removeFromWatchList(selectedCotegoryContent.vidLibId)
    } else {
      this.addInWatchList(selectedCotegoryContent.vidLibId)
    }
  }


  addInWatchList(vidLibId) {
    var userId = localStorage.getItem("userId");
    this.mycontentService.addInWatchList(userId, vidLibId).subscribe(result => { 
      console.log("after add watch list", result);
      if (result == 0) {
        // isEnable == false ? true : false;
        this.mapwatchContent();
        this.toaster.success("successfully added to the watchlist..");
      } else if (result == 1) {
        console.log("else block");
        this.toaster.success("unable to add please try again..");
      }
    })
    
  }


  removeFromWatchList(vidLibId) {
    // this.mycontentcompo.removeFromWatchList(isEnable, vidLibId);
    var userId = localStorage.getItem("userId");


    this.mycontentService.removeFromWatchList(userId, vidLibId).subscribe(result => { //126
      console.log("after remove watch list", result);
      if (result == 0) {
        // isEnable == false ? true : false;
        this.mapwatchContent();
        this.toaster.success("successfully removed to the watchlist..");
      } else if (result == 1) {
        this.toaster.success("unable to remove please try again..");
      }
    })


  }



  bannerImgUrl: any = [
    { img: "https://www.yashrajfilms.com/images/default-source/movies/shamshera/ranbir-kapoor-in-as-shamshera46a8a5a026f56f7f9f64ff0b00090313.jpg?sfvrsn=9f5dcacc_8" },
    { img: "https://stat1.bollywoodhungama.in/wp-content/uploads/2017/11/Jumanji-Welcome-to-The-Jungle-English-01-306x393.jpg" },
    { img: "https://cdn.gulte.com/wp-content/uploads/2022/07/thank-1.jpg" },
  ]

  bannerSlider: OwlOptions = {
    loop: true,
    dots: true,
    stagePadding: 60,
    
    navSpeed: 100,
    navText: ['<i class="fa fa-chevron-left"</i>', '<i class="fa fa-chevron-right"</i>'],
    responsive: {
      0: {
        items: 1,
        stagePadding: 0
      },
      400: {
        items: 1
      },
      740: {
        items: 1
      },
      940: {
        items: 1,
        stagePadding:0
      }
    },
    nav: true
  };

    
  customCarouselOptions: OwlOptions = {
    loop: false,
    mouseDrag: true,
    touchDrag: true,
    stagePadding: 0,
    pullDrag: true,
    dots: false,
    navSpeed: 700,    
    nav: true,
    navText: ['<i class="fa fa-chevron-left"</i>', '<i class="fa fa-chevron-right"</i>'],
    responsive: {
      0: {
        items: 1,
        stagePadding: 0
      },
      400: {
        items: 3
      },
      740: {
        items: 5
      },
      940: {
        items: 7,
        stagePadding: 0
      }

    }
  };

  // banSli: OwlOptions = {
  //   loop: true,
  //   dots: false,
  //   navSpeed: 700,
  //   navText: ['<i class="fa fa-caret-left"></i>', '<i class="fa fa-caret-right"></i>'],
  //   responsive: {
  //     0: {
  //       items: 5
  //     }
  //   },
  //   nav: true
  // };

  Cool(event: any, item: any) {
    this.mycontentService.setPopUpList(this);
    this.popUpBool = true;
    this.selectedCotegoryContent = item;//"https://cdn.gulte.com/wp-content/uploads/2022/07/thank-1.jpg";//this.thumbNail.filter((x: { tn: any; })=> x.tn == event.target.src)[0];
    console.log("selectedCotegoryContent: ", this.selectedCotegoryContent);
    

    item.properties.forEach( i=>{
      if(i.name=="channel"){
        this.selectedCotegoryContent.channel=i.value;
      }
    })
    let targetX = event.target.getBoundingClientRect().x;
    // // if(event.target.className === 'thumb-img'){
      targetX -= 30;
    // }
    this.positon.left = window.scrollX + targetX + 'px';
    this.positon.top = window.scrollY + event.target.getBoundingClientRect().y + 'px';
    const ele = document.getElementById("backgroung-img") as HTMLElement;
    this.positon.width = (event.target.className === 'thumb-img' ? ele.getBoundingClientRect().width : event.target.width) + 170 + 'px';
    this.positon.height = event.target.height + 150 + +'px';
  }
  @HostListener('document:click', ['$event'])
  Hot(event: any) {
    console.log("event target for thumb", event.target.className)
    if (!event.target.className.includes('thumb-img')) {

      this.popUpBool = false;
    }

  }
  getStreamFile(videoOrId: any, suffix: string = '_drm_meta.mpd'): string {
    return getVideoStreamFile(videoOrId, suffix);
  }

  async downloadFile(fileUrl, videoId) {
    this.downloadProgressService.resetDownloadItems();
    this.isVideoPlayerOpened = false;
    this.progressBarId = videoId;
    this.downloadingToast = false;    
    this.loaderShowHide = true;
    this.downloadProgressService.currentDownloadVideoId = videoId;
    this.downloadProgressService.isDownloadInprogress = true;

    // this.initPlayer()
  this.onDownloadClick(this.mediaUrl + fileUrl);
  //  this.listContent().then((content)=> {
  //    console.log("list content", content);
  //  })


//     this.downloadService.downloadProgress(this.mediaUrl + fileUrl).subscribe ((event) => {
//     // progress
//     this.downloadToastText = 'File is downloading...'
//     this.downloadingToast = true;
//     if (event.type === HttpEventType.DownloadProgress) {   
//      const percentage = Math.round(100 / event.total * event.loaded);
//      this.progressBarPer = percentage;
//    }
    
//    // finished
//    if (event.type === HttpEventType.Response) {
//      this.downloadToastText = 'File is Downloaded'
      
//       // fileSaver.
//       const link = document.createElement('a');
//       link.setAttribute('target', '_blank');
//       link.setAttribute('href', event.url);
//       link.setAttribute('download', event.url);
//       document.body.appendChild(link);
//       link.click();
//       link.remove();
//    }


//    if (this.progressBarPer === 100) {
//      setTimeout(() => {
//        this.loaderShowHide = false;
//        this.downloadingToast = false;
//         this.isDownloadedText = true;
        


//  this.categ.updateDownLoadVideosList = videoId;
//      }, 5000);
//    }
    
//  })
  }



  
  onCategoryClick(name: string, id: string,videoCount:number){
    localStorage.setItem('selectedCategoryName', name);
    this.router.navigate(['/tqr/percategory'], { queryParams: {categoryId: id,videoCount:videoCount}});
  }
 
}
